<template>
  <b-modal :active="errorModalOpen">
    <div >
    <div class="modal-header">
      <h1>{{ errorModalHeader }}</h1>
    </div>
    <div class="modal-body">
      <div>
        <b-icon
          style="color:#ff7800"
          class="exclamation-icon inline-block"
          icon="exclamation-triangle"
        ></b-icon>
        <h2 class="inline-block">{{errorModalText}}</h2>
      </div>
    </div>
    <div class="modal-footer">
      <b-button class="is-blue" @click="setConfirmed(true)">{{ confirmationButtonText }}</b-button>
      <b-button class="is-text" @click="setConfirmedAndClose(false)">Annullér</b-button>
    </div>
    </div>
  </b-modal>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "group-comment-modal",
  data: () => ({}),
  computed: {
    ...mapGetters("confirmationModalStore", [
      "errorModalOpen",
      "errorModalText",
      "errorModalHeader",
      "confirmationButtonText",
    ]),
  },
  methods: {
    ...mapActions("confirmationModalStore", ["setConfirmedAndClose", "setConfirmed"]),
  },
};
</script>

<style lang="scss" scoped>

.modal-header {
  border-radius: 10px 10px 0px 0px;
  background: white;
  height: 50px;
  width: 400px;
  text-align: start;
  margin: auto;
  h1 {
    padding: 10px;
    font-size: 20px;
  }
}
.modal-body {
  background: white;
  margin: auto;
  width: 400px;
  border-top: 1px solid lightgrey;
  height: 70px;
  h2 {
    font-size: 15px;
    padding: 12px 15px 15px 35px;
    width: 300px;
    text-align: start;
  }
}

.inline-block {
  display: inline-block;
}
.exclamation-icon {
  margin: 0;
  position: absolute;
  top: 45%;
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}

.modal-footer {
  background: white;
  width: 400px;
  border-top: 1px solid lightgrey;
  height: 70px;
  border-radius: 0px 0px 10px 10px;
  margin: auto;
}
.button {
  margin: 15px;
}
</style>
